import {
  type MutationFunction,
  type MutationKey,
  type UseMutationOptions,
  useMutation,
} from '@tanstack/react-query';

import { type ApiDataErrors, type UseMutationError } from '@/types/shared';

export const useDataMutation = <
  TData,
  TPayload,
  TError = ApiDataErrors,
  TOnMutateResult = unknown,
>(
  mutationKey: MutationKey,
  mutationFn: MutationFunction<TData, TPayload>,
  mutationOptions?: Omit<
    UseMutationOptions<TData, UseMutationError<TError, TPayload>, TPayload, TOnMutateResult>,
    'mutationKey' | 'mutationFn'
  >,
) => {

  const mutationResult = useMutation<TData, UseMutationError<TError, TPayload>, TPayload, TOnMutateResult>({
    mutationKey,
    mutationFn,
    ...mutationOptions,
  });

  return {
    ...mutationResult,
    isLoading: mutationResult.isPending,
  };
};
